import { useContext } from 'react'

import AuthContext from '../contexts/AuthorizationContext/AuthorizationContext'
import type { AuthContextType } from '../contexts/AuthorizationContext/AuthorizationType'

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext)

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }

  return context
}
